/**
 * Lookup option lists for the wizard's dropdowns.
 *
 * These mirror the lookup tables carried over from the previous attempt
 * (OfficerTitleType, AdditionalPeopleRoleType, BusinessReferenceType,
 * EntityOwnerPersonWorkTimeType). Held here while the API is mocked; once the
 * backend serves them, replace with a lookup query and keep the shape.
 */

export interface SelectOption {
    value: string;
    display: string;
}

export const SUFFIX_OPTIONS: SelectOption[] = [
    { value: 'Jr.', display: 'Jr.' },
    { value: 'Sr.', display: 'Sr.' },
    { value: 'II', display: 'II' },
    { value: 'III', display: 'III' },
    { value: 'IV', display: 'IV' },
];

/** Role within the borrower entity — BFIA-5100. */
export const ROLE_OPTIONS: SelectOption[] = [
    { value: 'CEO', display: 'CEO' },
    { value: 'CFO', display: 'CFO' },
    { value: 'COO', display: 'COO' },
    { value: 'Owner', display: 'Owner' },
    { value: 'Partner', display: 'Partner' },
    { value: 'Member', display: 'Member' },
    { value: 'Other', display: 'Other' },
];

/** Corporate officer title — BFIA-5100 / 5110. */
export const OFFICER_TITLE_OPTIONS: SelectOption[] = [
    { value: 'President', display: 'President' },
    { value: 'Vice President', display: 'Vice President' },
    { value: 'Secretary', display: 'Secretary' },
    { value: 'Treasurer', display: 'Treasurer' },
    { value: 'Officer', display: 'Officer' },
    { value: 'Other', display: 'Other' },
];

/** Business reference type — BFIA-5120. */
export const REFERENCE_TYPE_OPTIONS: SelectOption[] = [
    { value: 'Banking Reference', display: 'Banking Reference' },
    { value: 'Supplier Reference', display: 'Supplier Reference' },
    { value: 'Trade Reference', display: 'Trade Reference' },
    { value: 'Financial Reference', display: 'Financial Reference' },
    { value: 'Real Estate Reference', display: 'Real Estate Reference' },
];

/** Entity types for owner/borrower entities — BFIA-5098 / 5104. */
export const ENTITY_TYPE_OPTIONS: SelectOption[] = [
    { value: 'LLC', display: 'Limited Liability Company (LLC)' },
    { value: 'Corporation', display: 'Corporation' },
    { value: 'SCorporation', display: 'S Corporation' },
    { value: 'Partnership', display: 'Partnership' },
    { value: 'LimitedPartnership', display: 'Limited Partnership' },
    { value: 'SoleProprietorship', display: 'Sole Proprietorship' },
    { value: 'Trust', display: 'Trust' },
];

/** Earliest year offered by the "Year Incorporated" dropdowns. */
export const YEAR_INCORPORATED_START = 1900;
